<!-- <div class="layout-container">
  <app-sidebar />
  <main class="main-content">
    <app-navbar />
    <div class="page-content">
      <router-outlet />
    </div>
    <app-footer />
  </main>
</div> -->

<div class="layout-container">
  <app-sidebar />
  <main class="main-content">
    <app-navbar />
    <div class="page-content">
      <router-outlet />
    </div>
    <app-footer />
  </main>
</div>
